import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    width="7"
    height="10"
    viewBox="0 0 7 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Vector"
      d="M6.04176 9L2 5.01498L6.04176 1"
      stroke="#6A6783"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
  </svg>,
  "Back"
);
